import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_c251hgcw2g: FaireBrandEntity = {
  token: "b_c251hgcw2g",
  type: "brand",
  name: "Habilis Supply Co",
  avatarUrl:
    "https://cdn.faire.com/fastly/3037e86f774576aa41298cf846486173fa7825a10bbfe076bd080e33c94b0437.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/618e0be0a30990635905a0161366b1d0509fc19bc7974805cb1b635aa489bdf6.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/3037e86f774576aa41298cf846486173fa7825a10bbfe076bd080e33c94b0437.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/618e0be0a30990635905a0161366b1d0509fc19bc7974805cb1b635aa489bdf6.jpeg",
  location: "ALHAMBRA, CA, USA",
  minimumOrderDollars: 208,
  rating: 5,
  reviewCount: 23,
  isTopShop: true,
  isInsider: true,
  description:
    "Habilis Supply Co. is a California-based brand inspired by the enduring landscapes of the American West and our National Parks. Each piece begins as an original hand-drawn illustration, rooted in vintage design traditions and shaped by a deep appreciation for the outdoor space.\n\nWith over 20 years in the Los Angeles apparel industry, our founder brings a refined understanding of graphic storytelling and retail presentation. We create heritage-driven goods that feel collected over time — not trend-based, not mass-produced. Our aesthetic blends western nostalgia, national park iconography, and timeless typography into pieces with lasting character.\n\nAll products are designed and printed in the USA, ensuring consistent quality and dependable reorders for our retail partners. We focus on partnering with local manufacturers, with an eye on sustainability and durability.\n\nHabilis Supply Co. resonates strongly with national park gift shops, western boutiques, outdoor lifestyle retailers, and stores seeking elevated, American-made goods with authentic story and visual impact.\n\nWe create modern heirlooms — wearable pieces rooted in landscape, memory, and craft.",
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:52:21.061Z",
    importedBy: "entity-db-cli",
  },
};
